











































import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { FormVaildateToOut } from "@root/lib/decorator";
import { ProductChildren, channelAttributeParse } from "@root/lib/mixins";
const Root = namespace("root");

@Component({})
@FormVaildateToOut("form", {
  resCbName: "resFormart"
})
export default class channelDescriptionBlock extends Mixins(
  ProductChildren,
  channelAttributeParse
) {
  activeName = localStorage.getItem("channelLocale");
}
